import Keycloak from 'keycloak-js';

import { config } from '~shared/config';

export const KeycloakConfig = new Keycloak({
	url: config.keycloak.redirectUrl,
	realm: config.keycloak.realm,
	clientId: config.keycloak.clientId,
});
